import '@chillibean/component-library/index.css';

import { ToastNotifications, sizing } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import uuid from 'react-uuid';
import styled from 'styled-components';

import ErrorBoundary from '../FormTemplates/components/container/ErrorBoundary';
import { Sidebar } from './components/presentational';
import { Account } from './models';
import { setInternalSettings } from './redux/actions';
import store from './redux/store';
import routes from './routes';

export function Protocols(props) {
  const { account, token } = props;

  useEffect(() => {
    const internalValues = {
      account: new Account(account),
      authenticityToken: token,
    };

    store.dispatch(setInternalSettings(internalValues));
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <ErrorBoundary authenticityToken={token} errorRef={uuid()}>
          <ToastNotifications />
          <Wrapper>
            <Sidebar />
            <ProviderWrapper>
              <Switch>
                {routes.map((route) => {
                  return (
                    <Route
                      key={route.path}
                      exact={route.exact}
                      path={route.path}
                      render={() => <route.component subRoutes={route.subRoutes} />}
                    />
                  );
                })}
              </Switch>
            </ProviderWrapper>
          </Wrapper>
        </ErrorBoundary>
      </Router>
    </Provider>
  );
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  min-height: 80vh;
`;

const ProviderWrapper = styled.div`
  display: flex;
  width: 80%;
  height: 100%;
  flex-direction: column;
  padding-bottom: ${sizing.large};
`;

Protocols.propTypes = {
  account: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  token: PropTypes.string.isRequired,
};

export default Protocols;
